import React from "react";
import "./MobileFrame.css";

interface MobileFrameProps {
    children: React.ReactNode;
    label?: string;
}

export default function MobileFrame({ children, label = "운전자 앱 화면" }: MobileFrameProps) {
    const now = new Date();
    const h = now.getHours().toString().padStart(2, "0");
    const m = now.getMinutes().toString().padStart(2, "0");

    return (
        <div className="mf-wrap">
            {label && (
                <div className="mf-label">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <rect x="5" y="2" width="14" height="20" rx="2" ry="2" />
                        <line x1="12" y1="18" x2="12.01" y2="18" />
                    </svg>
                    {label}
                </div>
            )}
            <div className="mf-phone">
                {/* Dynamic Island */}
                <div className="mf-island">
                    <div className="mf-island-pill" />
                </div>

                {/* Status Bar */}
                <div className="mf-statusbar">
                    <span className="mf-time">{h}:{m}</span>
                    <div className="mf-icons">
                        {/* Signal bars */}
                        <svg width="15" height="11" viewBox="0 0 15 11" fill="white">
                            <rect x="0" y="8" width="2.5" height="3" rx="0.6" />
                            <rect x="3.5" y="5.5" width="2.5" height="5.5" rx="0.6" />
                            <rect x="7" y="3" width="2.5" height="8" rx="0.6" />
                            <rect x="10.5" y="0.5" width="2.5" height="10.5" rx="0.6" />
                            <rect x="14" y="0" width="0" height="0" rx="0" />
                        </svg>
                        {/* WiFi */}
                        <svg width="14" height="10" viewBox="0 0 16 12" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
                            <path d="M1 3.5C3.8 0.8 6 0 8 0s4.2 0.8 7 3.5" opacity="0.4" />
                            <path d="M3 6C4.8 4 6 3.2 8 3.2s3.2 0.8 5 2.8" opacity="0.7" />
                            <path d="M5.5 8.5C6.5 7.3 7 7 8 7s1.5 0.3 2.5 1.5" />
                            <circle cx="8" cy="11" r="1" fill="white" stroke="none" />
                        </svg>
                        {/* Battery */}
                        <svg width="22" height="11" viewBox="0 0 22 11" fill="none">
                            <rect x="0.5" y="0.5" width="17" height="10" rx="2.5" stroke="white" strokeOpacity="0.7" />
                            <rect x="18" y="3" width="3" height="5" rx="1.5" fill="white" fillOpacity="0.7" />
                            <rect x="1.5" y="1.5" width="13" height="8" rx="1.5" fill="white" />
                        </svg>
                    </div>
                </div>

                {/* Screen Content */}
                <div className="mf-screen">
                    {children}
                </div>

                {/* Home Indicator */}
                <div className="mf-home">
                    <div className="mf-home-bar" />
                </div>
            </div>
        </div>
    );
}
